import { render, staticRenderFns } from "./mCard.vue?vue&type=template&id=4df784eb&scoped=true"
import script from "./mCard.vue?vue&type=script&lang=ts"
export * from "./mCard.vue?vue&type=script&lang=ts"
import style0 from "./mCard.vue?vue&type=style&index=0&id=4df784eb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df784eb",
  null
  
)

export default component.exports